import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CustomersTable from './customers-table.jsx';
import PortalAccountsTable from '../portal-admin/portal-accounts-table.jsx';

if (document.getElementById('react-component-g4-logistics-portal-all-archived-customers')) {
  ReactDOM.render(
    <PortalAccountsTable
      url='/api/v1/portal/customers/all/archived'
      message_if_none = 'No Archived Customers found. Add one to see it here.'
      showCompanyName={true}
    />,
    document.getElementById('react-component-g4-logistics-portal-all-archived-customers')
  );
}